import { frontHostName, signupUrl } from '@config'

let sessionRef = null

export function setRouterSession (session) {
  sessionRef = session
}

function parseLocationParts () {
  const parts = window.location.href.split('.')
  let hostPart = parts[0]
  if (hostPart.includes('//')) hostPart = hostPart.split('//')[1]
  return { parts, hostPart }
}

function whitelabelFromUrlParts (parts) {
  if (parts.length <= 2) return ''
  const segment = parts[2] || ''
  if (
    segment.includes(process.env.DOMAIN_TARGET1) ||
    segment.includes(process.env.DOMAIN_TARGET2)
  ) {
    const pathParts = segment.split('/')
    if (pathParts[1] && pathParts[1].length > 0) {
      return pathParts[1]
    }
  }
  return ''
}

function isLiveOrStageHost (parts) {
  return (
    parts.length > 2 &&
    (parts[1] === process.env.STAGE_DOMAIN ||
      parts[1] === process.env.LIVE_DOMAIN)
  )
}

function loggedInDashboardUrl () {
  const whitelabel = sessionRef?.get('whitelabel') ?? ''
  const requestUserType = sessionRef?.get('requestUserType')
  const dashboardPath =
    requestUserType == 1 ? process.env.CAKE_ADMIN_PATH : process.env.CAKE_PATH

  if (whitelabel === '') {
    return frontHostName + (process.env.CAKE_BASE_PATH || '')
  }

  return frontHostName + process.env.CAKE_BASE_PATH + whitelabel + dashboardPath
}

function loginRouteLocation ({ whitelabel, query = {} }) {
  const nextQuery = { ...query }
  delete nextQuery.domain
  if (whitelabel) {
    return { path: `/${whitelabel}`, query: nextQuery, replace: true }
  }
  return { path: '/', query: nextQuery, replace: true }
}

export function setupRouterGuards (router) {
  router.beforeEach((to, from) => {
    const publicPages = ['/', 'ResponseForm', 'forgot-pswd']
    const authRequired =
      to.name === 'ResponseForm' || to.name === 'LabelLogin' || to.name === 'ForgotPassword' || to.name === 'SearchResponseForm'
        ? !publicPages.indexOf(to.name)
        : !publicPages.includes(to.path)

    if (window.location.pathname.toLowerCase().match(/\/signup\b/gi) !== null) {
      window.location.href = signupUrl
      return false
    }

    const reportsysURL = window.location.href.toLowerCase()
    if (reportsysURL.match(/\/reportsys\b/gi) !== null) {
      window.location.href = reportsysURL.replace('reportsys', 'my')
      return false
    }

    const loggedIn = localStorage.getItem('vue-session-key')

    if (authRequired && !loggedIn) {
      const reg = new RegExp(process.env.DOMAIN_REGEX)
      const { parts, hostPart } = parseLocationParts()
      if (isLiveOrStageHost(parts) && !reg.test(hostPart)) {
        const routepath = parts[2].split('/')
        const whitelabel = routepath[1]
        if (whitelabel && whitelabel.length > 0 && whitelabel !== 'forgot-pswd') {
          return loginRouteLocation({
            whitelabel,
            query: { redirect_url: to.query.redirect_url }
          })
        }
      }
      return '/'
    } else if (loggedIn) {
      if (to.name === 'Login' || to.name === 'LabelLogin' || to.name === 'SSOLogin') {
        window.location.href = loggedInDashboardUrl()
        return false
      }
      if (to.name === 'CreateForm' && from.name === 'Dashboard') {
        return from.path
      }
      if (to.name === 'EditForm' && from.name === 'Dashboard') {
        return from.path
      }
    }

    if (to.name === 'Login' || to.name === 'LabelLogin' || to.name === 'SSOLogin') {
      if (to.query?.domain) {
        const nextQuery = { ...to.query }
        delete nextQuery.domain
        return { path: to.path, query: nextQuery, replace: true }
      }

      const onlyDomainReg = new RegExp('\\b(' + process.env.ONLY_DOMAIN_REGEX + ')\\b')
      const { parts, hostPart } = parseLocationParts()
      const whitelabelFromUrl = whitelabelFromUrlParts(parts)
      const whitelabel =
        (to.params.whitelabel && to.params.whitelabel !== 'forgot-pswd')
          ? to.params.whitelabel
          : (whitelabelFromUrl === 'forgot-pswd' ? '' : whitelabelFromUrl)

      if (
        isLiveOrStageHost(parts) &&
        !onlyDomainReg.test(hostPart) &&
        hostPart.length > 0 &&
        whitelabel &&
        to.path !== `/${whitelabel}`
      ) {
        return loginRouteLocation({
          whitelabel,
          query: { redirect_url: to.query.redirect_url }
        })
      }
    }
  })
}
